import styled from 'styled-components'

import { Button } from 'components/Button'
import { Header } from 'components/Header'

import { Color } from 'root-constants'

export const StyledHolidayGift = {
  Header: styled(Header)`
    box-shadow: none;
    margin: 0 auto;
  `,
  Root: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    overflow: auto;
    align-items: center;
    background: linear-gradient(180deg, #f83b00 0%, #922300 100%);
  `,
  Wrapper: styled.div`
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  `,
  GiftWrapper: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    max-width: 360px;
    margin: 0 auto;
  `,

  Gift: styled.div`
    width: 280px;
    height: 280px;
    margin: 56px 0;
  `,
  Title: styled.h1`
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    color: ${Color.WHITE};
    margin-bottom: 24px;

    max-width: 343px;
  `,
  Footer: styled.div`
    padding-bottom: 40px;
    display: flex;
    align-items: center;
    flex-direction: column;
  `,
  Button: styled(Button)`
    background: ${Color.WHITE};
    color: #f83b00;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    z-index: 3;
  `,
}
